import { contract_01, contract_02, contract_03, doctorBanner } from "../../constants/images";

export const servicePlans = [
    {
        id:1,
      name: "service_title_mushlam_briut",
      description: "service_desc_mushlam_briut",
      img:contract_01,
      rate:4,
      votes:27,
      benefits: [
        "service_benefit_1_mushlam_briut",
        "service_benefit_2_mushlam_briut",
        "service_benefit_3_mushlam_briut",
        "service_benefit_4_mushlam_briut",
        "service_benefit_5_mushlam_briut",
        "service_benefit_6_mushlam_briut",
        "service_benefit_7_mushlam_briut",
        "service_benefit_8_mushlam_briut"
      ]
    },
    {
        id:2,
      name: "service_title_mushlam_plus",
      description: "service_desc_mushlam_plus",
      img:contract_02,
      rate:4,
      votes:217,
      benefits: [
        "service_benefit_1_mushlam_plus",
        "service_benefit_2_mushlam_plus",
        "service_benefit_3_mushlam_plus",
        "service_benefit_4_mushlam_plus",
        "service_benefit_5_mushlam_plus",
        "service_benefit_6_mushlam_plus",
        "service_benefit_7_mushlam_plus",
        "service_benefit_8_mushlam_plus",
        "service_benefit_9_mushlam_plus",
        "service_benefit_10_mushlam_plus"
      ]
    },
    {
        id:3,
      name: "service_title_mushlam_at_home",
      description: "service_desc_mushlam_at_home",
      img:contract_03,
      rate:5,
      votes:257,
      benefits: [
        "service_benefit_1_mushlam_at_home",
        "service_benefit_2_mushlam_at_home",
        "service_benefit_3_mushlam_at_home",
        "service_benefit_4_mushlam_at_home",
        "service_benefit_5_mushlam_at_home"
      ]
    }
  ];
  